import * as React from 'react';

export default ({size}: {size?: number}) => (
  <svg
    width={size ?? 50}
    height={size ?? 50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="50" rx="25" fill="#34C759" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2856 26.3852L21.3307 35.7146L35.7142 16.667"
      fill="#34C759"
    />
    <path
      d="M14.2856 26.3852L21.3307 35.7146L35.7142 16.667"
      stroke="white"
      strokeWidth="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
